import React from 'react';
import Header from 'cccisd-header';
import style from './style.css';

const Appdefs = window.cccisd.appDefs;
const Env = window.cccisd.env;
const Fortress = window.cccisd.fortress;
const wpUrl = Env.wpUrl || Appdefs.app.wpUrl;

export const publicRoutes = [
    { url: wpUrl, label: 'Home' },
    { url: '/online-training', label: 'Training' },
    { url: wpUrl + '/about', label: 'About' },
    { url: wpUrl + '/contact', label: 'Contact' },
    { url: wpUrl + '/faqs-2', label: 'FAQs' },
];

const AppHeader = ({ className, noLogoLink }) => {
    let routesToShow = [...publicRoutes];
    if (Fortress.user.acting.role.handle === 'uberadmin') {
        routesToShow = [
            ...publicRoutes,
            {
                url: '/manage',
                label: 'Manage',
            },
        ];
    }

    return (
        <div className={style.container}>
            <Header
                containerClassName={className}
                logoClassName={style.logo}
                primaryNavLinks={routesToShow}
                showHomeAction={false}
                showAlertAction={false}
                {...(noLogoLink ? { logoLink: null } : { logoLink: wpUrl })}
            />
        </div>
    );
};

AppHeader.defaultProps = {
    className: 'container-fluid',
};

export default AppHeader;
